import { Box, Button, Group, Loader, Tooltip } from '@mantine/core';
import { IconBrandTelegram, IconCheck } from '@tabler/icons-react';
import { iconProps } from 'components/icon-props';
import { i18nKeys, useTranslation } from 'locales';

type MailComposerActionsProps = {
  onClose: () => void;
  isSaveDraftLoading: boolean;
  isSavedAsDraft: boolean;
  isSendEmailLoading: boolean;
};

export const MailComposerActions = ({
  onClose,
  isSaveDraftLoading,
  isSavedAsDraft,
  isSendEmailLoading,
}: MailComposerActionsProps) => {
  const { t } = useTranslation();

  return (
    <Group gap="space2" justify="flex-end">
      {isSaveDraftLoading ? (
        <Loader size={14} />
      ) : isSavedAsDraft ? (
        <Tooltip label={t(i18nKeys.EXTERNAL_MAIL.DETAIL_NEXT.SAVED_AS_DRAFT)}>
          <Box display="flex">
            <IconCheck size={14} color="var(--mantine-color-green-6)" />
          </Box>
        </Tooltip>
      ) : null}
      <Button type="button" variant="subtle" color="gray" size="xs" onClick={onClose}>
        {t(i18nKeys.CANCEL)}
      </Button>
      <Button
        type="submit"
        size="xs"
        leftSection={<IconBrandTelegram {...iconProps(14)} />}
        loading={isSendEmailLoading}
      >
        {t(i18nKeys.SUBMIT)}
      </Button>
    </Group>
  );
};
